import React, { useState } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide"

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import bannerImage3 from "../../assets/images/bannerImage3.png";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "white",
  },
  paddingStyle: {
    padding: "0px 80px",
  },

  marginBottomStyle2: {
    marginBottom: "25px",
  },
  fontStyle: {
    fontSize: "14px",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "4px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    marginTop: "10px",
  },

  divStyle: {
    width: "70%",
    margin: "auto",
    "& img": {
      maxWidth: "100%",
    },
  },
  fieldWrapper: {
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 15,
    },
  },

  banner: {
    marginLeft: 90,
  },
  error: {
    marginBottom: 15,
  },
}));
const ResetPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [values, setValues] = React.useState({
    password: "",
    confirmPassword: "",
    showPassword: false,
  });
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let check = values.password.match(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@[-`{-~]).{6,64}$"
    );
    if (!check) {
      
      let er = "Must contain characters, Must have at least one uppercase letter, Must have one symbol, Must have one digit";

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
      setLoading(false);
      return;
    }

    try {
      let data = {
        email: location.state.email,
        otp: location.state.otp,
        newPassword: values.password,
        confirmNewPassword: values.confirmPassword,
      };
      let response = await axios({
        url: "/api/v1/public/auth/forgot-password/reset-password",
        method: "post",
        data: data,
      });
      history.push({
        pathname: "/reset-successful",
      });
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.root}
      >
        <Grid>
          <Header />
        </Grid>
        <Grid>
          <Grid container alignItems="center" className={classes.paddingStyle}>
            <Grid item xs={6}>
              <div
                className={classes.divStyle}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={bannerImage3} alt="" className={classes.banner} />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.divStyle}>
                <Typography variant="h3" className={classes.marginBottomStyle}>
                  Reset Password
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.marginBottomStyle2}
                >
                  Re-enter password
                </Typography>
                
                <form onSubmit={handleSubmit}>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12}>
                      <Typography className={classes.fontStyle} gutterBottom>
                        New Password
                      </Typography>
                      <FormControl
                        className={clsx(classes.margin, classes.textField)}
                        variant="outlined"
                        fullWidth
                        size="small"
                      >
                        <OutlinedInput
                          className={classes.fieldWrapper}
                          placeholder="Enter password"
                          id="outlined-adornment-password"
                          required
                          type={values.showPassword ? "text" : "password"}
                          value={values.password}
                          onChange={handleChange("password")}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.fontStyle} gutterBottom>
                        Confirm New Password
                      </Typography>
                      <FormControl
                        className={clsx(classes.margin, classes.textField)}
                        variant="outlined"
                        fullWidth
                        size="small"
                      >
                        <OutlinedInput
                          className={classes.fieldWrapper}
                          placeholder="Re-enter password"
                          id="outlined-adornment-re-password"
                          required
                          type={values.showPassword ? "text" : "password"}
                          value={values.confirmPassword}
                          onChange={handleChange("confirmPassword")}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      {loading ? <LinearProgress /> : null}
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.buttonStyle}
                        disabled={loading}
                      >
                        CONFIRM
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
};
export default ResetPassword;
